module.exports = __webpack_public_path__ + "static/media/course3.74655bf0.png";